import styled from 'styled-components';

export default styled.div`
  display: inline;
  width: 0.5rem;
  margin: 0 0 0 0.5rem;
  color: ${props => props.characterNum <= props.maxCharacters ? 'rgb(0, 215, 129)' : 'rgb(255, 98, 86)'}
`;
